import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { caseStudies, caseStudyOrder } from './caseStudiesData';
import './CaseStudies.css';

export const CaseStudies = () => {
  const reduced = useReducedMotion();

  const fade = {
    hidden: { opacity: 0, y: reduced ? 0 : 22 },
    visible: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: reduced ? 0.2 : 0.6, delay: reduced ? 0 : i * 0.08, ease: [0.16, 1, 0.3, 1] },
    }),
  };

  const [first, ...rest] = caseStudyOrder;
  const f = caseStudies[first];

  return (
    <div className="csi-page">
      <section className="csi-hero">
        <div className="csi-hero-glow" aria-hidden="true" />
        <motion.h1 className="csi-hero-title" initial="hidden" animate="visible" variants={fade}>
          Agents we’ve built that work in production.
        </motion.h1>
        <motion.p className="csi-hero-sub" initial="hidden" animate="visible" variants={fade} custom={1}>
          Real builds, real outcomes. Here’s what Liceron agents do for the businesses running them.
        </motion.p>
      </section>

      <section className="csi-grid">
        {/* Featured */}
        <motion.div
          initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-80px' }} variants={fade}
          className="csi-featured-wrap"
        >
          <Link to={`/case-studies/${first}`} className="csi-featured">
            <div className="csi-tags">
              <span className="csi-tag industry">{f.industry}</span>
              <span className="csi-tag type">{f.type}</span>
            </div>
            <h2 className="csi-featured-outcome">{f.outcome}</h2>
            <p className="csi-featured-summary">{f.summary}</p>
            <span className="csi-link">Read case study <ArrowRight size={15} /></span>
          </Link>
        </motion.div>

        <div className="csi-rest">
          {rest.map((slug, i) => {
            const c = caseStudies[slug];
            return (
              <motion.div
                key={slug}
                initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-80px' }} variants={fade} custom={i + 1}
                className="csi-compact-wrap"
              >
                <Link to={`/case-studies/${slug}`} className="csi-compact">
                  <div className="csi-tags">
                    <span className="csi-tag industry">{c.industry}</span>
                    <span className="csi-tag type">{c.type}</span>
                  </div>
                  <h3 className="csi-compact-outcome">{c.outcome}</h3>
                  <span className="csi-link">Read case study <ArrowRight size={14} /></span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </section>

      <section className="csi-cta">
        <div className="csi-cta-glow" aria-hidden="true" />
        <h2>Want results like these?</h2>
        <p>Tell us your problem. We’ll scope an agent in 24 hours.</p>
        <Link to="/contact" className="btn-primary">Book a Scoping Call <ArrowRight size={18} /></Link>
      </section>
    </div>
  );
};
